import React, { Component } from 'react';
import { Button, Card, Form, message, Table } from 'antd';
import moment from 'moment';

import { queryCustomContact, querySaveCustomContact, queryVerifyCustomContact } from '@api/crm/crm';
import { queryOrgList } from '@api/core/org';
import ModalContact from './ModalContact';
import ModalCheck from './ModalCheck';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      modalVisible: false,
      modalCheckVisible: false,
      pageNo: 1,
      total: 0,
    };
  }

  componentWillMount() {
    this.uuid = this.props.params.uuid;
  }

  componentDidMount() {
    this.getData();
    this.getOrgList();
  }

  getOrgList = () => {
    queryOrgList({
      type: 1,
    }).then(() => {});
  };

  getData = pageNo => {
    const no = this.state.pageNo;
    const current = pageNo || no;
    this.setState({
      pageNo: current,
    });
    queryCustomContact({
      start: current,
      customUuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: res.data,
          total: res.totalSize,
        });
      }
    });
  };

  saveContact = params => {
    querySaveCustomContact({
      ...params,
      custom: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.handleModalVisible(false);
        this.getData(1);
      } else {
        message.error(res.message);
      }
    });
  };

  handleChange = checked => {};

  handleSubmit = params => {
    this.saveContact(params);
  };

  // 核实联系记录
  handleCheckSubmit = params => {
    queryVerifyCustomContact({
      ...params,
      uuid: this.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.handleModalCheckVisible(false);
        this.getData();
      } else {
        message.error(res.message);
      }
    });
  };

  handleModalVisible = flag => {
    this.setState({
      modalVisible: !!flag,
    });
  };

  handleModalCheckVisible = (flag, uuid) => {
    this.uuid = uuid;
    this.setState({
      modalCheckVisible: !!flag,
    });
  };

  columns = () => {
    return [
      {
        title: '联系时间',
        dataIndex: 'date',
        render: (text, record, index) => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '备注',
        dataIndex: 'remark',
      },
      {
        title: '联系方式',
        dataIndex: 'tel',
      },
      {
        title: '联系记录',
        dataIndex: 'record',
      },
      {
        title: '操作',
        dataIndex: 'status',
        render: (text, record) => {
          return (
            <span>
              {text === 1 ? (
                <a>已核实</a>
              ) : (
                <a onClick={() => this.handleModalCheckVisible(true, record.uuid)}>核实</a>
              )}
            </span>
          );
        },
      },
    ];
  };

  render() {
    const { data, modalVisible, total, pageNo, modalCheckVisible } = this.state;
    const pagination = {
      showSizeChanger: false,
      pageSize: 15,
      total,
      current: pageNo,
      onChange: current => {
        this.getBusiness(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    const parentProps = {
      handleModalVisible: this.handleModalVisible,
      handleSubmit: this.handleSubmit,
    };
    const parentCheckProps = {
      handleModalVisible: this.handleModalCheckVisible,
      handleSubmit: this.handleCheckSubmit,
    };
    return (
      <Card>
        <div className="tableList">
          <div className="tableListOperator">
            <Button type="primary" onClick={() => this.handleModalVisible(true)}>
              添加
            </Button>
          </div>
        </div>
        <Table
          rowKey="uuid"
          rowSelection={{}}
          columns={this.columns()}
          dataSource={data}
          pagination={pagination}
        />
        {modalVisible ? <ModalContact {...parentProps} /> : null}
        {modalCheckVisible ? <ModalCheck {...parentCheckProps} /> : null}
      </Card>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Index);



// WEBPACK FOOTER //
// ./src/components/crm/custom/department/PageContact.js